import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../../components/loader";
import { addPayment } from "../../../actions/contracts";
import { fetchPaymentType } from "../../../actions/paymentType";

const $ = window.$;
// import { createAdministered } from '../../actions/administered';

const initialState = {
  method: "credit_debit",
  card_type: "visa",
  amount: 0,
  last_digits: "",
  other_type: "none",
  loading: false
};

class AddPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  submit = e => {
    e.preventDefault();
    this.setState({ loading: true });
    let data = {
      PetShopId: this.props.petShop.currentPetshop.id,
      ContractId: this.props.cId,
    };
    if(this.state.method == 'credit_debit'){
      data = {...data,     
        method: this.state.method,
        card_type: this.state.card_type,
        amount: this.state.amount,
        last_digits: this.state.last_digits
      }
      if(!data.card_type || !(data.amount>0) || !data.last_digits){
        NotificationManager.warning("Payment data incomplete.");
        this.setState({ loading: false });
      }
      else{
        this.props.addPayment(data)
      }
    }
    if(this.state.method == 'other'){
      data = {...data,        
        other_type: this.state.other_type,
        amount:this.state.amount      
      }
      if(data.other_type==='none' || !(data.amount>0)){
        NotificationManager.warning("Payment data incomplete.");
        this.setState({ loading: false });
      }
      else{
        this.props.addPayment(data)
      }
    }
    return
  };

  closeModal = () => {
    $("#add_payment").modal("hide");
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.newPayment !== nextProps.newPayment) {
      NotificationManager.success("Payment Added Successfully");
      $("#add_payment").modal("hide");
      this.setState(initialState);
    }
    if (this.props.paymentTypes !== nextProps.paymentTypes) {
      this.setState({ paymentTypes: nextProps.paymentTypes });
    }
  };
  componentDidMount = () => {
    this.props.fetchPaymentType();
  };
  changeVal = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const {
      method,
      amount,
      card_type,
      last_digits,
      other_type,
      paymentTypes
    } = this.state;

    return (
      <div
        className="modal fade show"
        id="add_payment"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="m-form">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  New Payment
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="m-form__section m-form__section--first">
                      <div className="form-group m-form__group row">
                        <label className="col-lg-4 col-form-label">
                          Payment Method
                        </label>
                        <div className="col-lg-8">
                          <select
                            type="text"
                            name="method"
                            onChange={this.changeVal}
                            className="form-control m-input"
                            defaultValue="other"
                            placeholder=""
                            value={method}
                          >
                            <option value="credit_debit">Credit/Debit</option>
                            <option value="other"> Other</option>
                          </select>
                        </div>
                      </div>
                      {method === "other" && (
                        <div className="form-group m-form__group row">
                          <label className="col-lg-4 col-form-label">
                            Payment Type
                          </label>
                          <div className="col-lg-8">
                            <select
                              type="text"
                              name="other_type"
                              onChange={this.changeVal}
                              className="form-control m-input"
                              placeholder=""
                              value={other_type}
                            >
                              <option value="none">None</option>
                              {paymentTypes.map(p => (
                                <option value={p.id}>{p.payment_type}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                      <div className="form-group m-form__group row">
                        <label className="col-lg-4 col-form-label">
                          Amount
                        </label>

                        <div className="col-lg-8">
                          <input
                            type="text"
                            name="amount"
                            onChange={this.changeVal}
                            className="form-control m-input"
                            placeholder=""
                            value={amount}
                          />
                          <span className="m-form__help">Enter the amount</span>
                        </div>
                      </div>

                      {method === "credit_debit" && (
                        <div>
                          <div className="form-group m-form__group row">
                            <label className="col-lg-4 col-form-label">
                              Card Type
                            </label>
                            <div className="col-lg-8">
                              <select
                                type="text"
                                name="card_type"
                                onChange={this.changeVal}
                                className="form-control m-input"
                                placeholder=""
                                value={card_type}
                              >
                                <option value="visa">Visa</option>
                                <option value="master">Master</option>
                                <option value="paywave">PayWave</option>
                              </select>
                            </div>
                          </div>
                          <div className="form-group m-form__group row">
                            <label className="col-lg-4 col-form-label">
                              Last 4 Digits
                            </label>
                            <div className="col-lg-8">
                              <input
                                type="number"
                                name="last_digits"
                                onChange={this.changeVal}
                                className="form-control m-input"
                                placeholder=""
                                value={last_digits}
                              />
                              <span className="m-form__help">
                                Enter the last 4 digits of card
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {/* <div>
                                    <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeModal}>Close</button>
                                    <button onClick={() => this.submit()} type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                                </div> */}
                {this.state.loading == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      onClick={this.closeModal}
                    >
                      Close
                    </button>
                    <button
                      onClick={e => this.submit(e)}
                      type="submit"
                      className="btn btn-primary m-btn--pill"
                    >
                      Submit
                    </button>
                  </div>
                ) : (
                  <div className="center-row">
                    <Loader size={50} />
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  petShop: state.petShopReducer,
  newPayment: state.contractsReducer.newPayment,
  paymentTypes: state.paymentTypeReducer.paymentTypes
});

const mapDispatchToProps = dispatch => ({
  addPayment: v => {
    dispatch(addPayment(v));
  },
  fetchPaymentType: () => {
    dispatch(fetchPaymentType());
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddPayment)
);
